import {
  takeLatest, call, put,
} from 'redux-saga/effects';
import { getAirFareRulesRequest, getAirFareRulesResponse } from '../../slices/flight';
import axios from '../axiosConfig';

function* getAirFareRulesWorker({
  payload: {
    flightItinerary,
    tripId,
  },
}) {
  try {
    const url = '/flights/airFareRules/itinerary';
    const config = {
      method: 'post',
      url,
      data: JSON.stringify(flightItinerary),
      headers: {
        'Content-Type': 'application/json',
      },
    };
    const { data } = yield call(axios, config);

    const airFareRulesList = (data && data.airFareRulesList) || [];

    yield put(getAirFareRulesResponse({
      tripId,
      error: null,
      errorCode: null,
      airFareRulesList,
    }));
  } catch (error) {
    let errorMessage = 'Unable to load fare rules';
    let errorCode = 'UNKNOWN_ERROR';

    if (error.response) {
      const { status, data: responseData } = error.response;

      if (responseData?.errorCode) {
        errorCode = responseData.errorCode;
      }

      if (status === 404) {
        errorCode = responseData?.errorCode || 'NOT_FOUND';
        errorMessage = responseData?.error || 'No fare rules found for this flight itinerary';
      } else if (status === 500) {
        errorCode = responseData?.errorCode || 'SERVER_ERROR';
        errorMessage = responseData?.Error || responseData?.error || 'Server error';
      }
    }
    yield put(getAirFareRulesResponse({ tripId, error: errorMessage, errorCode }));
  }
}

function* getAirFareRulesWatcher() {
  yield takeLatest(getAirFareRulesRequest.toString(), getAirFareRulesWorker);
}

export default getAirFareRulesWatcher;
